import { render } from "./railwayPage.vue?vue&type=template&id=2313c88c&scoped=true"
import script from "./railwayPage.vue?vue&type=script&lang=js"
export * from "./railwayPage.vue?vue&type=script&lang=js"

import "./railwayPage.vue?vue&type=style&index=0&id=2313c88c&lang=scss&scoped=true"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2313c88c"]])

export default __exports__